<div class="location-tree-node" [ngClass]="['level-' + level, active + '-' + level]">
	@if (!disableNestedSelection()) {
		<mat-icon
			class="node-toggle-arrow cursor-pointer accent-icon"
			[class.visibility-hidden]="!hasChildrens()"
			[attr.aria-label]="'Toggle ' + treeNode()?.name"
			(click)="toggleExpand()"
		>
			{{ isExpanded() ? 'expand_more' : 'chevron_right' }}
		</mat-icon>
	}
	@if (!disabledCheckboxes) {
		<mat-checkbox
			class="au-checkbox tree-node-checkbox"
			color="primary"
			[checked]="isSelected()"
			(change)="toggleNodeSelection()"
			[indeterminate]="descendantsPartiallySelected()"
		>
			{{ treeNode()?.name }}
		</mat-checkbox>
	}
	@if (disabledCheckboxes) {
		<div class="tree-node-title" (click)="toggleNodeSelection()">
			{{ treeNode()?.name }}
			@if (isSelected()) {
				<mat-checkbox [disabled]="true" [checked]="true" />
			}
		</div>
	}
</div>
